import {Component, OnInit} from '@angular/core';

import {AuthenticationService, AlertService, UserService} from '../_services/index';
import {ActivatedRoute, Router} from '@angular/router'; 
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-stripe-information',
  templateUrl: './stripe-information.component.html',
  styleUrls: ['./stripe-information.component.css']
})

export class StripeInformationComponent implements OnInit {
  model: any = {};
  logoimage: any;
  minLoader: any;
  loading: boolean;
  response: any = [];
  status: boolean;
  public sub:any;
  scope: string;
  code: string;
  state: string;

  constructor(public route: ActivatedRoute,private authenticationService: AuthenticationService,private http: HttpClient,private userService: UserService, private alertService: AlertService,private router: Router) {
  }

  ngOnInit() {
    this.minLoader = '../../assets/images/smallLoader.gif';
    this.logoimage = '../../assets/images/logo.png';
     this.sub = this.route.queryParams.subscribe(params => { 
        this.userService.getstripeinfo(params).subscribe(data => {
          if(data.status == 200){
            let resUpdated = JSON.parse(localStorage.getItem('currentUser'));
            if(resUpdated!=null){
             resUpdated.result.is_seller = 1;
            }
             localStorage.removeItem("currentUser");
              localStorage.setItem("currentUser", JSON.stringify(resUpdated));
              this.alertService.success('Account configured successfully', true);
              setTimeout(() => {
                if(resUpdated){
                  this.router.navigate(['/dashboard']);
                }else{
                  this.router.navigate(['/login']);
                }
              //this.router.navigate(['/login']);
            }, 2000);
          }
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
      });
  }


  resetPassword() {
    this.loading = true;
    this.authenticationService.resetPassword(this.model.email)
      .subscribe(
        data => {
          if (data.status === 200) {
            this.status = true;
          } else {
            this.status = false;
            data.message = 'Please enter registered Email!';
          }
          this.response = data;

          this.loading = false;
        },
        error => {
          this.loading = false;
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/stripe-information/stripe-information.component.ts